import { render, staticRenderFns } from "./CatchUpModal.vue?vue&type=template&id=ee15460c&scoped=true&"
import script from "./CatchUpModal.vue?vue&type=script&lang=js&"
export * from "./CatchUpModal.vue?vue&type=script&lang=js&"
import style0 from "./CatchUpModal.vue?vue&type=style&index=0&id=ee15460c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee15460c",
  null
  
)

export default component.exports